import { render, staticRenderFns } from "./UcContractServiceSelector.yaml?vue&type=template&id=1d01a0e5&component"
import script from "./UcContractServiceSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractServiceSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports